import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import KeepMeAliveView from "../views/KeepMeAliveView.vue";
import DefaultSettingsView from "../views/metadata/DefaultSettingsView.vue";
import ClassificationView from "../views/metadata/ClassificationView.vue";
import ReferencedObjectView from "../views/metadata/ReferencedObjectView.vue";
import FileView from "../views/metadata/FileView.vue";
import VdiViewer from "../views/VdiViewer.vue";
import DocumentVersionView from "../views/metadata/DocumentVersionView.vue";
import ObjectIdRefObjCom from "../components/referencedobject/ObjectIdRefObjCom.vue";
import OptionalDataRefObjCom from "../components/referencedobject/OptionalDataRefObjCom.vue";
import DescriptionRefObjCom from "../components/referencedobject/DescriptionRefObjCom.vue";
import PartyRefObjCom from "../components/referencedobject/PartyRefObjCom.vue";
import FileUploadCom from "../components/filerelated/FileUploadCom.vue";
import FileSelectionCom from "../components/filerelated/FileSelectionCom.vue";
import DocumentIdCom from "../components/organizationaldata/DocumentIdCom.vue";
import PartyCom from "../components/organizationaldata/PartyCom.vue";
import DocVersionPartyCom from "../components/documentversion/DocVersionPartyCom.vue";
import DocDescriptionDocVerCom from "../components/documentversion/DocDescriptionDocVerCom.vue";
import LifeCycleDocVerCom from "../components/documentversion/LifeCycleDocVerCom.vue";
// import DocRelationshipDocVerCom from "../components/documentversion/DocRelationshipDocVerCom.vue";
// import store from "../store/index";

const routes = [
  // login view

  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requireLogin: false,
    },
  },
  // children:[
  {
    path: "/privacy",
    name: "Privacy",
    // route level code-splitting
    // this generates a separate chunk (privacy.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue"),
  },
  {
    path: "/terms-of-use",
    name: "ToS",
    component: () =>
      import(/* webpackChunkName: "ToS" */ "../views/TermsOfUse.vue"),
  },
  {
    path: "/impressum",
    name: "impressum",
    component: () =>
      import(/* webpackChunkName: "impressum" */ "../views/Impressum.vue"),
  },
// ]


  {
    path: "/vdi2770viewer",
    name: "VdiViewer",
    component: VdiViewer,
    meta: {
      requireLogin: false,
    },
    children: [
      {
        path: "/vdi2770viewer/files",
        components: {
          default: FileUploadCom,

          second: FileSelectionCom,
        },
      },
    ],
  },
 
  {
    path: "/metadata",
    name: "KeepMeAliveView",
    component: KeepMeAliveView,
    meta: {
      requireLogin: false,
    },
    children: [
      {
        path: "/metadata/defaultsettings",
        redirect: "/metadata/defaultsettings/documentIdDomain/",
        name: "DefaultSettingsView",
        component: DefaultSettingsView,
        meta: {
          requireLogin: false,
        },
        children: [
          {
            path: "/metadata/defaultsettings/documentId/",
            component: DocumentIdCom,
            props: true,
          },
          {
            path: "/metadata/defaultsettings/documentIdDomain/",
            component: PartyCom,
            // props: true,
          },
        ],
      },
      {
        path: "/metadata/classification",
        name: "ClassificationView",
        component: ClassificationView,
        meta: {
          requireLogin: false,
        },
      },
      {
        path: "/metadata/refobject",
        redirect: "/metadata/refobject/objectid",
        name: "ReferencedObjectView",
        component: ReferencedObjectView,
        meta: {
          requireLogin: false,
        },
        children: [
          {
            path: "/metadata/refobject/objectid",
            component: ObjectIdRefObjCom,
          },
          {
            path: "/metadata/refobject/optional-data",
            component: OptionalDataRefObjCom,
          },
          { path: "/metadata/refobject/party", component: PartyRefObjCom },
          {
            path: "/metadata/refobject/description",
            component: DescriptionRefObjCom,
          },
        ],
      },
      {
        path: "/metadata/files",
        name: "/metadataFileView",
        component: FileView,

        meta: {
          requireLogin: false,
        },
        children: [
          { path: "/metadata/files/fileupload", component: FileUploadCom },
          {
            path: "/metadata/files/fileselection",
            component: FileSelectionCom,
          },
          {
            path: "/metadata/files/documentationname",
            component: FileView,
          },
        ],
      },
      {
        path: "/metadata/docversion",
        redirect: "/metadata/docversion/documentversionid/",
        name: "DocumentVersionView",
        component: DocumentVersionView,
        meta: {
          requireLogin: false,
        },
        children: [
          {
            path: "/metadata/docversion/DocumentVersionId",
            component: DocVersionPartyCom,
          },
          {
            path: "/metadata/docversion/documentdescription",
            component: DocDescriptionDocVerCom,
          },
          {
            path: "/metadata/docversion/lifecycle",
            component: LifeCycleDocVerCom,
          },
          // {
          //   path: "/metadata/docversion/relationship",
          //   component: DocRelationshipDocVerCom,
          // },
        ],
      },
    ],
  },

  // alway as last path, catch all
  { path: "/:notFound(.*)", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
